import SummaryContainer from './adapter';

export default SummaryContainer;
